import React from 'react';

import CollapsingList from '../../../../../general-ui/collapsing-list/collapsing-list';
import { SwitchNew } from '../../../../../general-ui/switch/switch-new';

import '../../../homepage/navigation/structure/edit-module-layout-modal/advanced-settings.scss';

interface IEventModalAdvancedSettingsProps {
	isSticky: boolean;
	isTransparent: boolean;
	setIsSticky: (isSticky: boolean) => void;
	setIsTransparent: (isTransparent: boolean) => void;
}

export default function EventModalAdvancedSettings({
	isSticky,
	isTransparent,
	setIsSticky,
	setIsTransparent,
}: IEventModalAdvancedSettingsProps): JSX.Element {
	const handleSetIsSticky = (_: string | undefined, checked: boolean): void => {
		setIsSticky(checked);
	};

	const handleSetIsTransparent = (_: string | undefined, checked: boolean): void => {
		setIsTransparent(checked);
	};

	return (
		<CollapsingList
			autoWidthTrigger
			label="Advanced settings"
			reverseIconPosition
		>
			<SwitchNew
				content="Sticky nav"
				checked={isSticky}
				onChange={handleSetIsSticky}
			/>
			<SwitchNew
				content="Transparent Background"
				checked={isTransparent}
				onChange={handleSetIsTransparent}
			/>
		</CollapsingList>
	);
}
